<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="capacity-list-content-loading" class="vs-con-loading__container">
		<vx-card
			no-shadow
			card-border
			:class="customHeight ? customHeight : 'custom-height'"
			:title="$t('Capacity.TotalCapacities') + ': ' + assignedCapacities.length"
		>
			<template slot="actions" v-if="navbarOptions">
				<div class="flex flex-row justify-between">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Capacity.AssignCapacity')"
						:text="$t('Capacity.AssigneCapacityTooltip')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-plus"
							:disabled="activeAlert2"
							@click.prevent="showCapacityList()"
						></vs-button>
					</vx-tooltip>
					<vx-tooltip
						v-if="assignedCapacities.length > 0"
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Crud.Delete')"
						:text="null"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-trash-2"
							@click.stop="openDeleteAllConfirm"
						></vs-button>
					</vx-tooltip>
					<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-layout"
						></vs-button>
						<vs-dropdown-menu style="width: 35%">
							<vx-card no-shadow :title="$t('AssignedTeams.Columns')">
								<p>{{ $t("AssignedTeams.ColumnsText") }}</p>
								<ul class="demo-alignment">
									<li>
										<vs-checkbox v-model="checkBoxName">{{ $t("Name") }}</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxDescription">{{ $t("Description") }}</vs-checkbox>
									</li>
								</ul>
							</vx-card>
						</vs-dropdown-menu>
					</vs-dropdown>
					<vx-tooltip
						v-if="capacityListIds.length > 0"
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Refresh')"
						:text="null"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-refresh-ccw"
							@click.stop="getAssignedCapacitiesByIds(capacityListIds)"
						></vs-button>
					</vx-tooltip>
				</div>
			</template>
			<vue-perfect-scrollbar :class="customHeight ? 'scroll-area--vehicle' : 'scroll-area'" :settings="settings">
				<vs-table
					v-if="assignedCapacities.length"
					ref="table"
					v-model="selected"
					search
					:max-items="itemsPerPage"
					:data="assignedCapacities"
				>
					<template slot="thead">
						<vs-th sort-key="name" v-show="enableHeadTable('name') && checkBoxName">{{ $t("Name") }}</vs-th>
						<vs-th sort-key="description" v-show="enableHeadTable('description') && checkBoxDescription">{{
							$t("Description")
						}}</vs-th>
						<vs-th v-if="isDemand">{{ $t("Routing.Table.Demand") }}</vs-th>
						<vs-th v-if="isTypeService">{{ $t("TypeOfService") }}</vs-th>
						<vs-th v-show="enableHeadTable('action')">{{ $t("Routing.Table.Actions") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td v-show="enableHeadTable('name') && checkBoxName">
									<p class="product-name font-medium truncate">{{ tr.name }}</p>
								</vs-td>
								<vs-td v-show="enableHeadTable('description') && checkBoxDescription">
									<p class="product-category">{{ tr.description | title }}</p>
								</vs-td>
								<vs-td v-if="isDemand" :data="data[indextr].id">
									<p v-if="!navbarOptions" class="product-name font-medium truncate">
										{{ data[indextr].demand }}
									</p>
									<span
										v-else-if="!data[indextr].isEditDemand"
										@click.prevent="editCellDemand(data[indextr])"
									>
										<span style="padding-left: 4px; margin-right: 10px">{{
											data[indextr].demand
										}}</span>
										<span :title="$t('Edit')" style="height: 30px">🖉</span>
									</span>
									<div v-else>
										<vs-input
											v-model="data[indextr].demand"
											type="number"
											ref="inputDemand"
											@keydown="onKeyDown($event, data[indextr])"
										/>
									</div>
								</vs-td>
								<vs-td v-if="isTypeService" :data="data[indextr].id">
									<p v-if="!navbarOptions" class="product-name font-medium truncate">
										{{ data[indextr].typeService === "PICKUP" ? $t("PICKUP") : $t("DELIVERY") }}
									</p>
									<span
										v-else-if="!data[indextr].isEditTypeService"
										@click.prevent="editCellTypeService(data[indextr])"
									>
										<span style="padding-left: 4px; margin-right: 10px">{{
											data[indextr].typeService === "PICKUP"
												? $t("PICKUP")
												: data[indextr].typeService === "DELIVERY"
												? $t("DELIVERY")
												: data[indextr].typeService === $t("PICKUP") ||
												  data[indextr].typeService === $t("DELIVERY")
												? data[indextr].typeService
												: data[indextr].typeService.label
										}}</span>
										<span :title="$t('Edit')" style="height: 30px">🖉</span>
									</span>
									<div v-else>
										<vx-card no-shadow>
											<div class="flex justify-start items-center" style="align-items: center">
												<v-select
													v-model="data[indextr].typeService"
													class="mr-2"
													:options="serviceTypeList"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
													:clearable="false"
												/>
												<span
													:title="$t('Edit')"
													style="cursor: pointer"
													@click.prevent="data[indextr].isEditTypeService = false"
													>✅</span
												>
											</div>
										</vx-card>
									</div>
								</vs-td>
								<vs-td v-show="enableHeadTable('action')" class="whitespace-no-wrap">
									<feather-icon
										icon="TrashIcon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-2"
										@click.stop="removeAssignedCapacity(tr.id)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p v-else-if="activeAlert2">
					<vs-alert
						class="mt-2"
						style="overflow-y: auto"
						color="warning"
						:active.sync="activeAlert2"
						:title="$t('Capacity.AssignCapabilities')"
					>
						{{ $t("Capacity.ThereAreCurrentlyNoCapabilitiesAvailable") }}
						<span
							class="text-inherit underline"
							style="cursor: pointer"
							@click.prevent="goRouter('CreateCapacity')"
						>
							<feather-icon class="cursor-pointer underline" icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							{{ $t("Capacity.AddCapacity") }}
						</span>
					</vs-alert>
				</p>
				<p v-else>
					{{ $t("Capacity.NoAssignedCapability") }}
				</p>
				<slot name="alert-message"> </slot>
			</vue-perfect-scrollbar>
			<vs-popup
				:fullscreen="true"
				:title="$t('Capacity.CapabilityList')"
				:active.sync="capacityMounted"
				class="vs-popup--content-custom"
			>
				<capacity-list
					v-if="capacityMounted"
					ref="capacityList"
					:customConfig="capacityListConfig"
					@showPopupEmmit="showPopup"
				>
					<div class="is-stuck" style="background: white">
						<vx-card
							ref="filterCard"
							:title="$t('Filters')"
							class="user-list-filters mb-8"
							no-shadow
							card-border
						>
							<template slot="actions">
								<div class="form-header-inner">
									<div v-if="isDemand || isTypeService">
										<vs-dropdown
											v-if="getCheckedCapacities.length > 0"
											vs-custom-content
											vs-trigger-click
											class="cursor-pointer"
											:title="$t('Capacity.MassiveActionsCapacities')"
										>
											<vs-button icon-pack="feather" icon="icon-settings">
												{{ windowWidth > 620 ? $t("BreakTable.Action") : null }}
												<vs-icon class="" icon="expand_more"></vs-icon>
											</vs-button>
											<vs-dropdown-menu>
												<span style="font-weight: 700; font-size: 1rem; padding-left: 5px">
													{{ $t("Crud.Update") + " " + $t("Routing.Title.VisitPoints") }}
												</span>
												<vs-collapse accordion>
													<vs-collapse-item v-if="isTypeService">
														<div slot="header">
															<span style="font-weight: 500; font-size: 1rem">{{
																$t("TypeOfService")
															}}</span>
														</div>
														<div class="flex justify-between items-center">
															<vx-card no-shadow>
																<v-select
																	v-model="serviceType"
																	class="w-full mb-2"
																	:options="serviceTypeList"
																	:dir="$vs.rtl ? 'rtl' : 'ltr'"
																	:clearable="false"
																/>
																<vs-button
																	class="float-right"
																	width="100%"
																	color="success"
																	type="border"
																	@click.prevent="updateService(serviceType)"
																>
																	{{ $t("Apply") }}
																</vs-button>
															</vx-card>
														</div>
													</vs-collapse-item>
													<vs-collapse-item v-if="isDemand">
														<div slot="header">
															<span style="font-weight: 500; font-size: 1rem">{{
																$t("Routing.Table.Demand")
															}}</span>
														</div>
														<vs-input
															v-model="amount"
															class="w-full mb-2"
															type="number"
															ref="inputDemand"
															@keydown="onKeyDown($event)"
														/>
														<vs-button
															class="float-right"
															width="100%"
															color="success"
															type="border"
															@click.prevent="updateDemand(amount)"
														>
															{{ $t("Apply") }}
														</vs-button>
													</vs-collapse-item>
												</vs-collapse>
											</vs-dropdown-menu>
										</vs-dropdown>
									</div>
									<vs-button
										:size="iconSize"
										class="ml-2"
										id="btn-locate-visit-point"
										icon-pack="feather"
										icon="icon-check"
										:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
										:disabled="getCheckedCapacities.length <= 0"
										@click.prevent="setAssignedCapacity()"
										>{{
											windowWidth > 620
												? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
												: null
										}}
									</vs-button>
								</div>
							</template>
							<div class="vx-row">
								<div class="vx-col w-full md:w-1/4">
									<label class="vs-input--label">{{ $t("SearchBy") }}</label>
									<v-select
										v-model="searchField"
										class="md:mb-1 mb-4"
										:clearable="false"
										:options="searchOptions"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
											<template v-else>
												{{ $t("NoResultsFound") }}
											</template>
										</template>
									</v-select>
								</div>
								<div class="vx-col w-full md:w-1/2">
									<div class="vx-row">
										<div class="vx-col w-full md:w-1/1">
											<tags-input
												class="w-full mt-2 md:mt-6"
												element-id="tags"
												v-model="searchQuery"
												add-tags-on-comma
												add-tags-on-blur
												:title="$t('SearchSeparatedByCommas') + '.'"
												:placeholder="$t('Teams.Form.Add') + ' ' + searchField.label"
												:typeahead="true"
												@keyup.enter="searchAssignedCapacity"
											></tags-input>
										</div>
									</div>
								</div>
								<div class="vx-col w-full md:w-1/4">
									<div class="flex items-center mt-2 md:mt-6">
										<vs-button
											:size="iconSize"
											:title="$t('Refresh')"
											class="ml-2"
											icon-pack="feather"
											icon="icon-refresh-cw"
											@click="refreshCapacity"
											>{{ windowWidth > 620 ? $t("Refresh") : null }}</vs-button
										>
										<vs-button
											:size="iconSize"
											:title="$t('VisitPoints.Search')"
											class="ml-2"
											icon-pack="feather"
											icon="icon-search"
											@click.prevent="searchAssignedCapacity"
											>{{ windowWidth > 620 ? $t("VisitPoints.Search") : null }}</vs-button
										>
									</div>
								</div>
							</div>
						</vx-card>
					</div>
					<vs-divider class="d-theme-border-grey-light" />
				</capacity-list>
			</vs-popup>
		</vx-card>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import CapacityList from "./CapacityList.vue";
import vSelect from "vue-select";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

const KEY_BACKSPACE = "Backspace";
const KEY_F2 = "F2";
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";
const KEY_ESC = "Escape";
export default {
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		VuePerfectScrollbar,
		CapacityList,
	},
	props: {
		columns: {
			type: Array,
			default: () => ["name", "description", "amountVehicles", "amountVisitPoints", "action"],
		},
		defaultColumns: {
			type: Array,
			default: () => ["name", "description", "amountVehicles", "amountVisitPoints", "action"],
		},
		navbarOptions: {
			type: Boolean,
			default: true,
		},
		multiple: {
			type: Boolean,
			default: true,
		},
		capacityListIds: {
			type: Array,
			default: () => [],
		},
		capacities: {
			type: Array,
			default: () => [],
		},
		customHeight: {
			type: String,
			default: "",
		},
		isDemand: {
			type: Boolean,
			default: true,
		},
		isTypeService: {
			type: Boolean,
			default: true,
		},
		isAssignedCapacities: {
			type: Boolean,
			default: () => true,
		},
	},
	data() {
		return {
			activeItem: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			selected: [],
			capacityMounted: false,
			itemsPerPage: 7,
			isMounted: false,
			searchQuery: [],
			searchField: {value: "Name", label: this.$t("Routing.Table.Name")},
			checkBoxName: true,
			checkBoxDescription: true,
			amount: "",
			serviceType: {value: "PICKUP", label: this.$t("PICKUP")},
			valCellOldDemand: 0,
			valCellOldTypeService: "",
			capacityListFetched: false,
			activeAlert2: false,
			capacityListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "demand", "typeService", "amountVehicles", "amountVisitPoints"],
				actionDropdown: false,
				btnAssig: true,
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				filterHead: false,
				CellRendererDemand: this.isDemand,
				CellRendererTypeService: this.isTypeService,
			},
		};
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		this.checkBoxNameLocal = this.defaultColumns.includes("name");
		this.checkBoxDescription = this.defaultColumns.includes("description");
	},
	mounted() {
		this.isMounted = true;
		if (this.capacityListIds && this.capacityListIds.length > 0 && this.isAssignedCapacities) {
			this.getAssignedCapacitiesByIds(this.capacityListIds);
		}
	},
	computed: {
		enableHeadTable() {
			return (headName) => this.columns.includes(headName);
		},
		assignedCapacities() {
			if (this.capacities && this.capacities.length > 0 && (this.isDemand || this.isTypeService)) {
				for (let visitPoint of this.$store.state.moduleCapacity.listSelectedCapacities) {
					for (let capacity of this.capacities) {
						if (capacity.capacity_id === visitPoint.id) {
							visitPoint.demand = capacity.amount;
							visitPoint.typeService = capacity.job_type;
						}
					}
				}
			}
			return this.$store.state.moduleCapacity.listSelectedCapacities;
		},
		getCheckedCapacities() {
			return this.$store.state.moduleCapacity.checkedCapacities;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		searchOptions() {
			return [
				{value: "Id", label: "ID"},
				{value: "Name", label: this.$t("Routing.Table.Name")},
			];
		},
		serviceTypeList() {
			return [
				{value: "PICKUP", label: this.$t("PICKUP")},
				{value: "DELIVERY", label: this.$t("DELIVERY")},
			];
		},
	},
	methods: {
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Capacity.Messages.DeleteAll"),
				accept: this.deleteAll,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		},
		showPopup(val) {
			this.capacityMounted = val;
		},
		removeAssignedCapacity(id) {
			this.$store.commit("moduleCapacity/REMOVE_ASSIGNED_CAPACITY", id);
		},
		async getAssignedCapacitiesByIds(ids) {
			this.openLoadingContent("#capacity-list-content-loading");
			await this.$store.dispatch("moduleCapacity/findCapacityFilter", {
				id: ids,
				fields: ["id", "name", "description"],
				assigned: true,
			});
			this.closeLoadingContent("#capacity-list-content-loading");
		},
		refreshCapacity() {
			this.$refs.capacityList.refresh();
			this.searchQuery = [];
			this.searchField = {value: "Name", label: this.$t("Routing.Table.Name")};
		},
		searchAssignedCapacity() {
			this.$refs.capacityList.searchAssignedCapacity(this.searchField.value, this.searchQuery, 1);
		},
		setAssignedCapacity() {
			const selectedRows = [...this.getCheckedCapacities];
			this.$store.commit("moduleCapacity/SET_ASSIGNED_CAPACITY", selectedRows);
			this.capacityMounted = false;
			this.searchQuery = [];
		},
		onKeyDown(event, val) {
			if (this.isLeftOrRight(event) || this.isBackspace(event)) {
				event.stopPropagation();
				return;
			}
			if (this.isEsc(event)) {
				val.demand = this.valCellOldDemand;
				val.isEditDemand = false;
			}
			if (!this.finishedEditingPressed(event) && !this.isKeyPressedNumeric(event)) {
				if (event.preventDefault) event.preventDefault();
			} else if (this.finishedEditingPressed(event)) {
				val.isEditDemand = false;
			}
		},
		isCharNumeric(charStr) {
			return /\d/.test(charStr);
		},
		isKeyPressedNumeric(event) {
			const charStr = event.key;
			return this.isCharNumeric(charStr);
		},
		finishedEditingPressed(event) {
			const key = event.key;
			return key === KEY_ENTER || key === KEY_TAB;
		},
		isBackspace(event) {
			return event.key === KEY_BACKSPACE;
		},
		isEsc(event) {
			return event.key === KEY_ESC;
		},
		isLeftOrRight(event) {
			return ["ArrowLeft", "ArrowRight"].indexOf(event.key) > -1;
		},
		editCellDemand(data) {
			this.valCellOldDemand = data.demand;
			data.isEditDemand = true;
		},
		editCellTypeService(data) {
			let typeServiceValue;
			if (data.typeService === "PICKUP") {
				typeServiceValue = this.$t("PICKUP");
			} else if (data.typeService === "DELIVERY") {
				typeServiceValue = this.$t("DELIVERY");
			} else if (data.typeService === this.$t("PICKUP") || data.typeService === this.$t("DELIVERY")) {
				typeServiceValue = data.typeService;
			} else {
				typeServiceValue = data.typeService.label;
			}
			data.typeService = typeServiceValue;
			this.valCellOldTypeService = data.typeService;
			data.isEditTypeService = true;
		},
		updateDemand(amount) {
			if (amount !== undefined && amount !== null && amount !== "" && amount > 0) {
				this.$refs.capacityList.updateDemand(amount);
				this.amount = "";
			}
		},
		updateService(type) {
			this.$refs.capacityList.updateService(type.value);
			this.serviceType = {value: "PICKUP", label: this.$t("PICKUP")};
		},
		async showCapacityList() {
			if (this.capacityListFetched) {
				this.capacityMounted = true;
				return;
			}
			this.capacityListFetched = true;
			try {
				const res = await this.$store.dispatch("moduleCapacity/findAll");
				if (res.data.length > 0) {
					this.activeAlert2 = false;
					this.capacityMounted = true;
				} else {
					this.activeAlert2 = true;
				}
			} catch (err) {
				console.error(err);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 450px;
}
.con-vs-dropdown--menu {
	z-index: 54000 !important;
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.capacity-info--form {
	height: 445px !important;
}
.scroll-area--vehicle {
	margin: auto;
	width: 100%;
	min-height: 350px;
	max-height: 350px;
}
</style>
